export class 期限切れ破棄破損採用品型 {
  商品区分: string;
  使用区分: string;
  JANコード: string;
  メーカー名: string;
  商品名: string;
  規格容量: string;
  単価: number;
  箱単価: number;
  商品名カナ: string;
  商品コード: string;
  包装GTINコード: string;
  販売GTINコード: string;
  バラ単位区分: string;
  数量単位: string;

  constructor(商品区分: string,
              使用区分: string,
              JANコード: string,
              メーカー名: string,
              商品名: string,
              規格容量: string,
              単価: number,
              箱単価: number,
              商品名カナ: string,
              商品コード: string,
              包装GTINコード: string,
              販売GTINコード: string,
              バラ単位区分: string,
              数量単位: string) {
    this.商品区分 = 商品区分;
    this.使用区分 = 使用区分;
    this.JANコード = JANコード;
    this.メーカー名 = メーカー名;
    this.商品名 = 商品名;
    this.規格容量 = 規格容量;
    this.単価 = 単価;
    this.箱単価 = 箱単価;
    this.商品名カナ = 商品名カナ;
    this.商品コード = 商品コード;
    this.包装GTINコード = 包装GTINコード;
    this.販売GTINコード = 販売GTINコード;
    this.バラ単位区分 = バラ単位区分;
    this.数量単位 = 数量単位;
  }
}

export function 期限切れ破棄破損採用品初期値() {
  return new 期限切れ破棄破損採用品型('', '', '', '', '', '',
                                  0.000, 0.000, '', '', '',
                                  '', '', '');
}
